import { useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Action, {
  ACTIONS,
} from "@/components/editor/primitives/legacy/action/action-component";
import {
  NavigationMenu,
  StandaloneNavigationSettings,
} from "@/components/editor/shared/navigation";
import Element from "@/components/element/element-component";

import StandaloneNavigationList from "./standalone-navigation-settings";
import { CTAButtonWrapper, Wrapper } from "./standalone-navigation-styles";

export type StandaloneNavigationProps = {
  children?: React.ReactNode;
  isSticky?: boolean;
  showCta?: boolean;
  backgroundColor?: string;
};

export default function StandaloneNavigation(props: StandaloneNavigationProps) {
  const {
    connectors: { connect },
    id,
  } = useNode();

  return (
    <Wrapper
      id={id}
      ref={connect}
      className={props.isSticky ? "block-sticky" : undefined}
    >
      <NavigationMenu
        isCentered={!props.showCta}
        cta={
          props.showCta && (
            <CTAButtonWrapper>
              <Element
                id="cta-button"
                element="button"
                is={Action}
                text="Tickets"
                style={{
                  padding: [
                    `${rem(0)} ${rem(40)}`,
                    `${rem(6)} ${rem(40)}`,
                    `${rem(6)} ${rem(40)}`,
                  ],
                  width: "100%",
                  maxWidth: rem(300),
                }}
                action={ACTIONS.registrationPage}
                actions={[ACTIONS.registrationPage, ACTIONS.externalLink]}
                showOptions
              />
            </CTAButtonWrapper>
          )
        }
        menu={
          props.children ? (
            props.children
          ) : (
            <Element
              canvas
              id="standalone-navigation"
              is={StandaloneNavigationList}
            >
              {["About", "Speakers", "Schedule", "Sponsors", "Expo"].map(
                (text) => {
                  return (
                    <Action
                      key={text}
                      element="link"
                      text={text}
                      style={{
                        display: "block",
                        padding: [
                          `${rem(0)} ${rem(12)}`,
                          `${rem(0)} ${rem(12)}`,
                          `${rem(0)} ${rem(12)}`,
                        ],
                        lineHeight: rem(32),
                        backgroundColor: "transparent",
                        fontSize: rem(14),
                      }}
                      actions={[
                        ACTIONS.sectionOfPage,
                        ACTIONS.registrationPage,
                        ACTIONS.externalLink,
                      ]}
                    />
                  );
                }
              )}
            </Element>
          )
        }
      />
    </Wrapper>
  );
}

StandaloneNavigation.craft = {
  isCanvas: true,
  custom: {
    displayName: "Standalone navigation",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: StandaloneNavigationSettings,
  },
};
